import * as React from 'react';

const NoLeads: React.FC<React.SVGProps<SVGSVGElement>> = () => (
	<svg
		xmlns='http://www.w3.org/2000/svg'
		width='160'
		height='160'
		viewBox='0 0 160 160'
		fill='none'>
		<path
			d='M123 96C123 110.912 110.912 123 96 123C81.0883 123 69 110.912 69 96C69 81.0883 81.0883 69 96 69C110.912 69 123 81.0883 123 96Z'
			fill='black'
		/>
		<foreignObject x='5' y='5' width='149' height='149'>
			<div
				style={{
					backdropFilter: 'blur(15px)',
					clipPath: 'url(#bgblur_0_3004_71435_clip_path)',
					height: '100%',
					width: '100%',
				}}
			/>
		</foreignObject>
		<path
			data-figma-bg-blur-radius='30'
			d='M35 112V47C35 40.3726 40.3726 35 47 35H112C118.627 35 124 40.3726 124 47V80.0933L78.9067 124H47C40.3726 124 35 118.627 35 112Z'
			fill='#D3D3D3'
			fillOpacity={0.3}
		/>
		<path
			d='M79 88V124L124 80H87C82.5817 80 79 83.5817 79 88Z'
			fill='#D9D9D9'
			fillOpacity={0.2}
		/>
		<path
			d='M46 56.9214C46 55.6196 47.0553 54.5643 48.3571 54.5643H65.6429C66.9447 54.5643 68 55.6196 68 56.9214C68 58.2232 66.9447 59.2786 65.6429 59.2786H48.3571C47.0553 59.2786 46 58.2232 46 56.9214Z'
			fill='white'
		/>
		<path
			d='M57.1571 46C58.459 46 59.5143 47.0553 59.5143 48.3571V65.6429C59.5143 66.9447 58.459 68 57.1571 68C55.8553 68 54.8 66.9447 54.8 65.6429L54.8 48.3571C54.8 47.0553 55.8553 46 57.1571 46Z'
			fill='white'
		/>
		<defs>
			<clipPath id='bgblur_0_3004_71435_clip_path' transform='translate(-5 -5)'>
				<path d='M35 112V47C35 40.3726 40.3726 35 47 35H112C118.627 35 124 40.3726 124 47V80.0933L78.9067 124H47C40.3726 124 35 118.627 35 112Z' />
			</clipPath>
		</defs>
	</svg>
);

export default NoLeads;
